import { useEffect, useState } from "react";
import { toast } from "sonner";
import { ChevronDown } from "lucide-react";
import { api, errMsg } from "../../lib/api";
import { ddmmyyyy, inr, num } from "../../lib/format";
import { diffClass, diffLabel } from "./GRNItemCard";

const VendorRow = ({ v }) => {
  const [open, setOpen] = useState(false);
  const t = `shortage-vendor-${v.vendor_code}`;
  return (
    <div className="panel overflow-hidden" data-testid={t}>
      <button type="button" onClick={() => setOpen(!open)} className="w-full space-y-2 p-4 text-left transition-colors hover:bg-muted/40" data-testid={`${t}-toggle`}>
        <div className="flex items-start justify-between gap-3">
          <div className="min-w-0">
            <p className="truncate font-semibold">{v.vendor_name}</p>
            <p className="mono text-xs text-muted-foreground">{v.vendor_code} · {v.grns} GRN{v.grns === 1 ? "" : "s"}</p>
          </div>
          <ChevronDown size={18} className={`mt-1 shrink-0 text-muted-foreground transition-transform ${open ? "rotate-180" : ""}`} />
        </div>
        {v.by_uom.length === 0 ? (
          <p className="text-sm text-muted-foreground">No short or excess supply</p>
        ) : v.by_uom.map((u) => (
          <div key={u.uom} className="grid grid-cols-2 gap-2 text-sm" data-testid={`${t}-${u.uom}`}>
            <span className="mono font-bold text-destructive">Short {num(u.short)} {u.uom}</span>
            <span className="mono font-bold text-amber-600 dark:text-amber-400">Excess {num(u.excess)} {u.uom}</span>
          </div>
        ))}
        {v.by_uom.length > 0 && (
          <p className="mono text-xs text-muted-foreground" data-testid={`${t}-values`}>Short value {inr(v.short_value)} · Excess value {inr(v.excess_value)}</p>
        )}
      </button>
      {open && v.lines.length > 0 && (
        <div className="rise divide-y border-t bg-muted/20 px-4">
          {v.lines.map((l, i) => (
            <div key={i} className="space-y-0.5 py-3 text-sm" data-testid={`${t}-line-${i}`}>
              <div className="flex justify-between gap-3">
                <span className="min-w-0 font-semibold">{l.description} {l.code && <span className="mono text-xs text-muted-foreground">[{l.code}]</span>}</span>
                <span className={`mono shrink-0 font-bold ${diffClass(l.difference)}`}>{diffLabel(l.difference)}</span>
              </div>
              <p className="mono text-xs text-muted-foreground">
                {l.grn_no} · {l.po_no} · {ddmmyyyy(l.grn_date)} · invoice {num(l.qty_invoice)} / received {num(l.qty_received)} {l.uom} · {inr(l.value)}
              </p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export const ShortageSummary = () => {
  const [list, setList] = useState(null);
  useEffect(() => {
    api.get("/grns/vendor-summary").then((r) => setList(r.data)).catch((e) => toast.error(errMsg(e)));
  }, []);
  if (!list) return <p className="text-muted-foreground">Loading…</p>;
  if (!list.length) return <p className="panel p-6 text-center text-muted-foreground" data-testid="shortage-empty">No GRNs yet.</p>;
  return (
    <div className="space-y-3" data-testid="shortage-summary">
      <p className="text-xs text-muted-foreground">Difference = quantity received minus quantity as per vendor invoice, totalled across all GRNs. Tap a vendor for item-wise lines.</p>
      {list.map((v) => <VendorRow key={v.vendor_code} v={v} />)}
    </div>
  );
};
